// extracted by mini-css-extract-plugin
export default {"title":"_c3bb212c","description":"_666b78ca"};